import React from 'react';
import { dataHooks } from '../../constants';
import { classes, st } from '../../ListItemAction.st.css.js';
export const PrefixIcon = ({ prefixIcon, size, subtitle, }) => {
    return React.cloneElement(prefixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: st(classes.prefixIcon, { subtitle: Boolean(subtitle) }),
        'data-hook': dataHooks.prefixIcon,
    });
};
//# sourceMappingURL=PrefixIcon.js.map